export interface MistakePair {
  problem: string
  problemDetail: string
  solution: string
  solutionDetail: string
}

export interface Pillar {
  icon: string
  label: string
}

export interface AreaCard {
  icon: string
  label: string
  detail: string
}

export const problems: string[] = [
  'Entrás a tu casa y no terminás de sentir esa calma que te gustaría.',
  'Hay rincones que siempre se sienten desordenados, vacíos o desaprovechados.',
  'Tu dormitorio está lindo, pero no se siente realmente como un espacio pensado para descansar.',
  'Trabajás desde casa y te cuesta concentrarte o desconectar al terminar.',
  'Elegiste colores, muebles y objetos por estética, pero nunca pensaste cómo interactúan entre sí.',
  'Querés renovar tu hogar, pero no sabés qué cambiar ni por dónde empezar.',
]

export const mistakes: MistakePair[] = [
  {
    problem: 'Tu cama está donde simplemente “entraba”',
    problemDetail: 'Sin considerar cómo se siente la ubicación dentro del dormitorio.',
    solution: 'Aprendé la posición de mando',
    solutionDetail: 'Descubrí cómo trabajar su ubicación buscando mayor estabilidad y comodidad.',
  },
  {
    problem: 'Tu entrada está bloqueada o sin intención',
    problemDetail: 'Objetos acumulados, poca luz o una circulación incómoda.',
    solution: 'Creá una bienvenida más armónica',
    solutionDetail: 'Favorecé una circulación clara desde el primer paso.',
  },
  {
    problem: 'Elegís colores y materiales al azar',
    problemDetail: 'Sin comprender qué aportan al equilibrio del ambiente.',
    solution: 'Equilibrá los cinco elementos',
    solutionDetail: 'Aprendé a trabajar Madera, Fuego, Tierra, Metal y Agua.',
  },
  {
    problem: 'Tu escritorio queda de espaldas a la entrada',
    problemDetail: 'Una distribución que puede sentirse incómoda o poco funcional.',
    solution: 'Diseñá una posición más consciente',
    solutionDetail: 'Favorecé enfoque, comodidad y sensación de control.',
  },
  {
    problem: 'Tenés rincones que no sabés cómo aprovechar',
    problemDetail: 'Espacios olvidados o sin una función clara.',
    solution: 'Descubrí qué representa cada sector',
    solutionDetail: 'Aprendé a analizar tu hogar utilizando el Mapa Bagua.',
  },
]

export const pillars: Pillar[] = [
  { icon: '☯', label: 'Equilibrio' },
  { icon: '🌿', label: 'Energía' },
  { icon: '🏡', label: 'Espacios' },
  { icon: '✨', label: 'Intención' },
]

export const areas: AreaCard[] = [
  { icon: '💰', label: 'Abundancia', detail: 'Prosperidad y oportunidades' },
  { icon: '❤️', label: 'Amor', detail: 'Vínculos y relaciones' },
  { icon: '🌿', label: 'Bienestar', detail: 'Salud y equilibrio' },
  { icon: '💼', label: 'Carrera', detail: 'Trabajo y propósito' },
  { icon: '✨', label: 'Reconocimiento', detail: 'Visibilidad y logros' },
  { icon: '🏡', label: 'Familia', detail: 'Raíces y pertenencia' },
  { icon: '🎨', label: 'Creatividad', detail: 'Expresión y proyectos' },
  { icon: '🌱', label: 'Nuevos comienzos', detail: 'Cambios y claridad' },
]

export const guideFeatures: string[] = [
  'Explicado paso a paso',
  'Pensado para principiantes',
  'Casas y departamentos',
  'Ejemplos prácticos',
  'Ejercicios y checklists',
  'Aplicación inmediata',
]

export const notNeeded: string[] = [
  'No necesitás reformar tu casa',
  'No necesitás comprar muebles nuevos',
  'No necesitás vivir en una casa grande',
  'No necesitás saber de decoración',
  'No necesitás gastar una fortuna',
  'No necesitás conocimientos previos',
]

export const heroPills: string[] = [
  'Feng Shui desde cero',
  'Casas y departamentos',
  'Sin grandes reformas',
  'Aplicación práctica',
]
